import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class NationsService {
    countryMap: Record<string, string> = {
        "Belgium": "BE",
        "Republic of Ireland": "IE",
        "Colombia": "CO",
        "Sweden": "SE",
        "Slovakia": "SK",
        "Spain": "ES",
        "Türkiye": "TR",
        "France": "FR",
        "Luxembourg": "LU",
        "Bosnia and Herzegovina": "BA",
        "Japan": "JP",
        "Brazil": "BR",
        "Ecuador": "EC",
        "Netherlands": "NL",
        "Slovenia": "SI",
        "Congo DR": "CD",
        "Angola": "AO",
        "Germany": "DE",
        "Senegal": "SN",
        "Morocco": "MA",
        "Norway": "NO",
        "Denmark": "DK",
        "Côte d'Ivoire": "CI",
        "Mexico": "MX",
        "Nigeria": "NG",
        "Switzerland": "CH",
        "Serbia": "RS",
        "England": "GB",
        "Guinea-Bissau": "GW",
        "Tunisia": "TN",
        "Portugal": "PT",
        "Algeria": "DZ",
        "USA": "US",
        "Gabon": "GA",
        "Italy": "IT",
        "Austria": "AT",
        "Mali": "ML",
        "Cyprus": "CY",
        "Ghana": "GH",
        "Argentina": "AR",
        "Canada": "CA",
        "Australia": "AU",
        "Madagascar": "MG",
        "Malta": "MT",
        "Romania": "RO",
        "Egypt": "EG",
        "Gambia": "GM",
        "Iceland": "IS",
        "Greece": "GR",
        "Albania": "AL",
        "Czechia": "CZ",
        "Cameroon": "CM",
        "Poland": "PL",
        "Suriname": "SR",
        "Togo": "TG",
        "New Zealand": "NZ",
        "Wales": "GB",
        "Georgia": "GE",
        "Philippines": "PH",
        "Uruguay": "UY",
        "Chile": "CL",
        "North Macedonia": "MK",
        "Croatia": "HR",
        "Montenegro": "ME",
        "Russia": "RU",
        "Mauritania": "MR",
        "South Korea": "KR",
        "Moldova": "MD",
        "Kosovo": "XK",
        "Ukraine": "UA",
        "Guinea": "GN",
        "Israel": "IL",
        "Paraguay": "PY",
        "Bulgaria": "BG",
        "Finland": "FI",
        "Tanzania": "TZ",
        "Haiti": "HT",
        "Hungary": "HU",
        "Peru": "PE",
        "Armenia": "AM",
        "Benin": "BJ",
        "Venezuela": "VE",
        "Panama": "PA",
        "Burkina Faso": "BF",
        "Curaçao": "CW",
        "IR Iran": "IR",
        "Zambia": "ZM",
        "Jamaica": "JM",
        "Cabo Verde": "CV",
        "South Africa": "ZA",
        "Martinique": "MQ",
        "Congo": "CG",
        "Kazakhstan": "KZ",
        "Comoros Islands": "KM",
        "Indonesia": "ID",
        "Zimbabwe": "ZW",
        "Jordan": "JO",
        "Vietnam": "VN",
        "Equatorial Guinea": "GQ",
        "Guadeloupe": "GP",
        "Syria": "SY",
        "Central African Republic": "CF",
        "Chad": "TD",
        "China PR": "CN",
        "Honduras": "HN",
        "Sierra Leone": "SL",
        "Mozambique": "MZ",
        "Costa Rica": "CR",
        "French Guiana": "GF",
        "Grenada": "GD",
        "Bahrain": "BH",
        "Estonia": "EE",
        "Liberia": "LR",
        "Kenya": "KE",
        "Lithuania": "LT",
        "Uzbekistan": "UZ",
        "Azerbaijan": "AZ",
        "Libya": "LY",
        "Latvia": "LV",
        "Burundi": "BI",
        "Iraq": "IQ",
        "Palestine": "PS",
        "Bolivia": "BO",
        "Cuba": "CU",
        "Aruba": "AW",
        "Uganda": "UG",
        "Dominican Republic": "DO",
        "Belarus": "BY",
        "Rwanda": "RW",
        "Guatemala": "GT",
        "St. Kitts and Nevis": "KN",
        "Trinidad and Tobago": "TT",
        "Niger": "NE",
        "Bonaire": "BQ",
        "Malaysia": "MY",
        "Thailand": "TH",
        "El Salvador": "SV",
        "Pakistan": "PK",
        "Saudi Arabia": "SA",
        "Faroe Islands": "FO",
        "Turkmenistan": "TM",
        "Saint Martin": "MF",
        "Mauritius": "MU",
        "Mongolia": "MN",
        "Guyana": "GY",
        "Netherlands Antilles": "AN"
    }  
    getSortedCountries() {
        return Object.keys(this.countryMap).sort((a, b) => a.localeCompare(b))
    }
}